import { useEffect } from 'react';
import { useNavVisibility } from '../contexts/NavVisibilityContext';

/**
 * Hook para esconder os navs (header e footer) quando um modal está aberto
 * @param {boolean} isOpen - Estado do modal (aberto/fechado)
 */
export const useHideNavOnModal = (isOpen) => {
  const { hideNav, showNav } = useNavVisibility();

  useEffect(() => {
    if (isOpen) {
      hideNav();
      // Salva a posição de scroll atual
      const scrollY = window.scrollY;
      // Previne scroll do body e fixa na posição atual
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      showNav();
      // Restaura scroll do body
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      // Restaura a posição de scroll
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    // Cleanup: garantir que o nav seja mostrado e scroll restaurado
    return () => {
      showNav();
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };
  }, [isOpen, hideNav, showNav]);
};
